import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight } from 'lucide-react';
import { format } from 'date-fns';

export default function BlogCard({ post }) {
  const date = post.published_at ? format(new Date(post.published_at), 'MMM d, yyyy') : '';
  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group bg-card border border-border overflow-hidden flex flex-col transition-all duration-300 hover:border-primary/50"
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden bg-background">
        {post.image_url && (
          <img
            src={post.image_url}
            alt={post.title}
            className="w-full h-full object-cover opacity-60 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
            loading="lazy"
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent" />
        <span className="absolute top-3 left-3 bg-primary text-background px-3 py-1 font-mono text-[10px] uppercase tracking-wider font-bold">
          {post.category}
        </span>
      </div>

      {/* Content */}
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-center gap-3 font-mono text-[10px] text-muted-foreground uppercase mb-3">
          {date && (
            <span className="flex items-center gap-1">
              <Calendar className="w-3 h-3" />
              {date}
            </span>
          )}
          {post.read_time && (
            <span className="flex items-center gap-1">
              <Clock className="w-3 h-3" />
              {post.read_time}
            </span>
          )}
        </div>

        <h3 className="font-heading font-bold text-lg text-foreground leading-snug group-hover:text-primary transition-colors mb-2">
          {post.title}
        </h3>

        <p className="text-sm text-muted-foreground leading-relaxed flex-1 line-clamp-3">
          {post.subtitle || post.meta_description}
        </p>

        <div className="mt-4 flex items-center gap-1 font-heading font-bold text-xs uppercase tracking-wider text-primary">
          Read Article
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
}